<template>
  <b-modal ref="modal" centered @hidden="cancelModal" modal-class="modal-condensed" size="xl" hide-footer style="height: 550px;" >
    <template slot="modal-header">
      <h1>{{ Translations.sections.similarTracks.sectionTitle }}</h1>
      <div>
        <Button :empty="true" class="close-popup" @click.prevent="cancelModal">{{ Translations.buttons.cancel }}</Button>
        <Button :empty="true" :noBorder="true" color="#d2d2d2" class="validate" @click.prevent="validate">Done</Button>
      </div>
    </template>

    <template style="height: 500px;" >
      <div class="search-container" style="height: 500px;" >
        <div class="search-content" >
<!--          <div class="row form-group">-->
<!--             <input  class="form-control"   type="text" style="width: 650px;">-->
<!--            <i class="fas fa-search"></i>-->
<!--          </div>-->
<!--          <br>-->
          <div class="row" style="right: -2%; top: 25px; position: relative;">
            <span v-if="!isLoadingTracks" style="    position: relative;left: 40%;">Loading tracks list ...</span>
          <PickList v-model="filteredList" dataKey="id" listStyle="height:342px;     width: 450px;"  rendered="" v-if="isLoadingTracks">
            <template #sourceheader >
              <input  class="search-input"   type="text" v-model="unSelectedTrack"> <i class="fas fa-search search-icon" ></i> <br>
              <div style="position: relative;
                          margin: 2px;
                          left: 30%;
                          color: #a6a6a6;
                          padding-top: 7px;">Unassigned : {{filteredList[0] && filteredList[0].length}} / {{similarTrack[0] && similarTrack[0].length}}</div>
            </template>
            <template #targetheader >
              <input  class="search-input"  type="text" v-model="selectedTrack">  <i class="fas fa-search search-icon"></i> <br>
              <div style="position: relative;
                          margin: 2px;
                          left: 30%;
                          color: #a6a6a6;
                          padding-top: 7px;">Assigned   : {{filteredList[1].length && filteredList[1].length}} / {{similarTrack[1].length && similarTrack[1].length}}</div>
            </template>
            <template #item="slotProps" >
              <div  class="flex flex-wrap p-2 align-items-center gap-3">
                <div class="w-4rem border-round"><PlayButton class="control" :track="slotProps.item"></PlayButton></div>
                <div class="flex-1 flex flex-column gap-2">
                  <span class="font-bold">{{  slotProps.item.title }}</span>
                  <div class="flex align-items-center gap-2">
                    <span style="overflow: hidden">{{ slotProps.item.artist }}</span>
                  </div>
                </div>
                <span style="position: absolute; right: 15px;"> {{ slotProps.item.count }}</span>
              </div>
            </template>
          </PickList>
          </div>
        </div>
      </div>
    </template>

    <template slot="modal-footer">
      <div></div>
    </template>
  </b-modal>
</template>

<script>
  import Button from'@/components/common/Button';
  import Bootstrap from 'bootstrap-vue';
  import Translations from '@/store/translations';
  import Portlet from '@/components/common/Portlet.vue';
  import { HTTP } from '@/utils/http';
  import Apis from '@/apis/index';
  import WaitingBlock from'@/components/common/WaitingBlock';
  import PickList from 'primevue/picklist';
  import PlayButton from "@/components/common/PlayButton";

  export default {
    name: 'SelectorSimilarTracks',
    components: {Portlet, Bootstrap, Button, WaitingBlock, PickList , PlayButton},
    computed: {
      Translations: () => Translations,
      filteredList: {
        get() {
          if (this.unSelectedTrack.length === 0 && this.selectedTrack.length === 0) return this.similarTrack
          if (this.unSelectedTrack.length > 0) return [this.similarTrack[0].filter(item => {
            return item.title.toLowerCase().includes(this.unSelectedTrack.toLowerCase())
          }), this.similarTrack[1]];
          if (this.selectedTrack.length > 0) return [this.similarTrack[0], this.similarTrack[1].filter(item => {
            return item.title.toLowerCase().includes(this.selectedTrack.toLowerCase())
          })];
        },
        set(value) {
          if (this.unSelectedTrack.length === 0 && this.selectedTrack.length === 0) this.similarTrack = value;
          if (value && value[0].length > 0) {
            for (let i = 0; i < value[0].length; i++) {
              let index0 = this.similarTrack[0].filter(item => {
                return value[0][i].title === item.title
              })
              if (index0.length === 0) {
                this.similarTrack[0].push(value[0][i]);
                this.similarTrack[1] = this.similarTrack[1].filter(item => {
                  return value[0][i].title !== item.title
                })
              }
            }
          }
          if (value && value[1].length > 0) {
            for (let i = 0; i < value[1].length; i++) {
              let index0 = this.similarTrack[1].filter(item => {
                return value[1][i].title === item.title
              })
              if (index0.length === 0) {
                this.similarTrack[1].push(value[1][i]);
                this.similarTrack[0] = this.similarTrack[0].filter(item => {
                  return value[1][i].title !== item.title
                })
              }
            }
          }
        }
      },
    },
    watch: {
      stationMusicBoxes: {
        handler: function (newData) {
          // save selected boxes to a further using
          this.$store.commit('Boxes/SAVE_SELECTED_BOXES', newData)
        }
      },
    },
    props: {
      stationUid: {required: true},
      trackUid: {required: true},
      boxUid: {required: true},
      noModalEdit: null,
    },
    mounted() {

    },
    data() {
      return {
        similarTrack: [],
        currentData: null,
        isLoadingTracks: false,
        modalState: {
          hasSearchProcessed: false,
          isCreationActive: false,
          isLoadingArtists: false,
          delayedSearch: null
        },
        isSearchActive: false,
        activeStation: null,
        stations: [],
        stationBoxes: {},
        selectedBoxes: {},
        searchStation: '',
        unSelectedTrack: '',
        selectedTrack: '',
      };
    },
    methods: {
      // ------------------------------------------------------
      /* Start : Common Behaviour                            */
      // ------------------------------------------------------
      show(value) {
        console.log(value)
        this.trackUid = value[0].uid;
        this.loadSimilarTracks();
        this.$refs.modal.show();
      },
      hide() {
        this.similarTrack =[];
        this.$refs.modal.hide();
      },
      cancelModal() {
        this.$emit("onHidden");
        this.$refs['modal'].hide();
      },
      // Load Similar traks list
      async loadSimilarTracks() {
        console.log('this.trackUid' , this.trackUid)
        this.similarTrack =[];
        const response = await HTTP.get(Apis.boxes.similarTracks, {
          params: {
            stationUid: this.stationUid,
            trackUid: this.trackUid,
            sortField: "artist",
            sortAscending: true,
            pageSize: 100,
            page: 0
          }
        });

        if (response.data.dataItem) {
          console.log(response.data.dataItem)
          this.similarTrack = [response.data.dataItem.tracks , [] ]
          this.isLoadingTracks = true;
        }
      },
      validate() {
        if(this.similarTrack[1].length > 0) {
          let trackUids = [];
          for (let i = 0; i < this.similarTrack[1].length; i++) {
            console.log(this.similarTrack[1][i].title)
            trackUids.push(this.similarTrack[1][i].uid)
          }
          var response = HTTP.post(Apis.boxes.linkTracks, {
            'stationUid': this.stationUid,
            'boxUid': this.boxUid,
            'trackUids': trackUids,
          }).then(response => {

            console.log(response)
            if (response.data.isSuccess) {
              this.$store.dispatch('Toasts/addToast', {
                title: 'Success',
                message: 'Success link Tracks to this box',
                type: 'success'
              }, {root: true});
              this.$emit('refreshData', true);
            }else{
              this.$store.dispatch('Toasts/addToast', {
                title: 'Error',
                message: `An error occurs while moving the track : ${message || error.message}`,
                type: 'danger'
              });

            }
          })
        }

        this.hide();
      },
    }

  }
</script>

<style lang="scss" scoped>

h4 {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.7px;
  line-height: 1;
  margin:0;padding:0;
}


.search-container {
  overflow: hidden;
  height: 100%;
  height:400px;
  display:flex;
  flex-direction:column;
  flex-grow: 1;
  justify-content: stretch;
  align-self: flex-start;
  ul{
    height: 100%;
    overflow: auto;
    input{
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.7px;
      line-height: 1;
    }
    li {
      span{
        font-weight:600;
        font-size:12px
      }
      span.badge {
        font-weight:400;
        font-size:10px
      }
    }
  }
}

.box-source-wrapper {
  position: relative;
  padding-left: 25px;

  i {
    position: absolute;
    left: 0;
    top: 5px;
  }
}

.search-container .search-content {
  display: flex;
  flex-grow: 1;
  flex-direction: column ;
  flex-shrink: 0;
  height: 100%;
}



.search-container header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  padding: 10px 15px;
  border-bottom: var(--COLOR_BORDERS) 1px solid;
}

.search-container header h4 {
  margin: 0;
}

.search-input{
  width: 380px; border-radius: 7px; border-bottom: white;background-color: white;
}
.search-icon{
  color: grey;
  margin-left: 5px;
}
</style>

